import { createGlobalState } from 'react-hooks-global-state'

const webHeaderAccountMenu = createGlobalState({
  isOpen: false,
})

export default webHeaderAccountMenu
